export default __webpack_public_path__ + "static/media/DEBoK_Brain.58c21276.png";